export default {
    async getConfig({commit}) {
        const resp = await window.axios.get('/config');
        commit('setConfig', resp.data);
    },
}
